var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOnboardingRemote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1156 38.5778H5.60007C4.56917 38.5778 3.7334 37.742 3.7334 36.7111V5.6C3.7334 2.51216 6.24556 0 9.3334 0H54.3823C57.4701 0 59.9823 2.51216 59.9823 5.6V36.7111C59.9823 37.742 59.1465 38.5778 58.1156 38.5778Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3828 0H31.8584V38.5778H58.1162C59.1471 38.5778 59.9828 37.742 59.9828 36.7111V5.6C59.9828 2.51216 57.4707 0 54.3828 0Z",
    fill: "#4E4E4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4668 38.5769H56.249V5.59909C56.249 4.56981 55.4116 3.73242 54.3824 3.73242H9.33346C8.30418 3.73242 7.4668 4.56981 7.4668 5.59909V38.5769Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1271 38.5756H13.1938C12.1629 38.5756 11.3271 37.7398 11.3271 36.7089V34.2201C11.3271 29.0737 15.5141 24.8867 20.6605 24.8867C25.8069 24.8867 29.9938 29.0737 29.9938 34.2201V36.7089C29.9938 37.7398 29.158 38.5756 28.1271 38.5756Z",
    fill: "#FFA826"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6562 27.998C17.3968 27.998 14.7451 25.3463 14.7451 22.0869C14.7451 18.8274 17.3968 16.1758 20.6562 16.1758C23.9157 16.1758 26.5673 18.8274 26.5673 22.0869C26.5673 25.3463 23.9157 27.998 20.6562 27.998Z",
    fill: "#FFCFBE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3828 3.7334H31.8584V38.5778H56.2495V5.60007C56.2495 4.57079 55.4121 3.7334 54.3828 3.7334Z",
    fill: "#F9F9F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73529 36.374L0.120798 46.0126C0.0421487 46.2222 0.00195312 46.4442 0.00195312 46.6681C0.00195312 47.699 0.837722 48.5347 1.86862 48.5347H61.8508C62.8817 48.5347 63.7175 47.699 63.7175 46.6681C63.7175 46.4442 63.6773 46.2222 63.5987 46.0126L59.9842 36.374H3.73529Z",
    fill: "#9C9C9C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 50.4003C0 53.4882 2.51216 56.0003 5.6 56.0003H58.1156C61.2034 56.0003 63.7156 53.4882 63.7156 50.4003V46.667H0V50.4003Z",
    fill: "#858585"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5192 22.404H33.7192C33.0722 22.404 32.4714 22.069 32.1313 21.5187C31.7912 20.9684 31.7603 20.2813 32.0495 19.7026L34.3414 15.1189V9.33737C34.3414 8.30647 35.1772 7.4707 36.2081 7.4707H50.5192C51.5501 7.4707 52.3859 8.30647 52.3859 9.33737V20.5374C52.3859 21.5683 51.5501 22.404 50.5192 22.404Z",
    fill: "#6AA5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnboardingRemote);
export default __webpack_public_path__ + "static/media/icon_onboarding_remote.777f825284ec813c2c325ba949905554.svg";
export { ForwardRef as ReactComponent };